import LoadJs from 'loadjs'

export default async () => {
  !window.Vue && (window.Vue = require('vue').default)

  await LoadJs(
    [
      new URL('./lib/@meta-vue/sider-menu/v1.10.2/meta-sider-menu.umd.min.js', location.href).href
    ],
    {
      returnPromise: true
    }
  )
  return window['meta-sider-menu']
}

function getTimestamp() {
  // 单位：分钟
  const step = 30 // 30分钟
  const time = new Date()
  time.setMinutes(Math.round(time.getMinutes() / step) * step)
  time.setSeconds(0)
  time.setMilliseconds(0)

  return +time
}
